import { GIZMO_SCALE, GIZMO_WALL_WIDTH } from '@constants'
import { useLightEvents3D } from '@hooks/useLightEvents3D'
import { PivotControls } from '@react-three/drei'
import { useAppStore } from '@store'
import toQuaternion from '@utils/conversion/toQuaternion'
import { toVector3 } from '@utils/conversion/toVector3'
import { shouldAxesActivate } from '@utils/sceneObjects/items/shouldAxesActivate'
import { Matrix4 } from 'three'

type Props = {
  pivotKey: string
  id: string
  matrix?: Matrix4
  disableRotations?: boolean
  children: JSX.Element | JSX.Element[]
}

export function LightPivot({ pivotKey, id, matrix, children }: Props) {
  const isSelected = useAppStore((store) => store.layers[store.currentLayer].selected.has(id))
  const mode = useAppStore.use.mode()
  const { handleDrag, handleDragEnd, handleDragStart } = useLightEvents3D(id)
  const prefs = useAppStore.use.prefs()
  const position = toVector3()
  matrix?.decompose(position, toQuaternion(), toVector3())

  // Obtener el tipo de luz
  const lightType = useAppStore((store) => store.items.get(id)?.lightType)
  const showGizmos = lightType !== 'directionallight'

  return (
    <PivotControls
      userData={{ pivotControlsVisible: true }}
      key={pivotKey}
      matrix={matrix?.clone()}
      depthTest={false}
      disableRotations={false}
      onDrag={(l) => handleDrag(l)}
      autoTransform={true}
      onDragEnd={handleDragEnd}
      onDragStart={handleDragStart}
      scale={GIZMO_SCALE}
      lineWidth={GIZMO_WALL_WIDTH}
      axisColors={[prefs['C/GIZMOX'], prefs['C/GIZMOZ'], prefs['C/GIZMOY']]}
      activeAxes={
        showGizmos ? shouldAxesActivate(isSelected, mode) : [false, false, false]
      }
      disableScaling
    >
      {children}
    </PivotControls>
  )
}
